import React from 'react';
import Spinner from '@atlaskit/spinner';
function getSpinnerAppearance({
  appearance,
  isDisabled,
  isSelected
}) {
  if (isDisabled) {
    return 'inherit';
  }
  if (isSelected) {
    return 'invert';
  }
  if (appearance === 'primary' || appearance === 'danger') {
    return 'invert';
  }
  return 'inherit';
}
export default function LoadingSpinner({
  spacing = 'default',
  ...rest
}) {
  const size = spacing === 'default' ? 'medium' : 'small';
  return /*#__PURE__*/React.createElement(Spinner, {
    size: size,
    appearance: getSpinnerAppearance(rest)
  });
}